import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';
import NvBulletedList from '../NvBulletedList/NvBulletedList.esm.js';
import NvHeading from '../NvHeading/NvHeading.esm.js';
import NvNumberedList from '../NvNumberedList/NvNumberedList.esm.js';
import { NvTableMarkdown } from '../NvTableMarkdown/NvTableMarkdown.esm.js';
import { addSuperscript, addVimeoVideo } from './customRules.esm.js';

var NvMarkdown = function (_a) {
    var className = _a.className, _b = _a.children, children = _b === void 0 ? '' : _b, _c = _a.options, options = _c === void 0 ? {} : _c, withoutBodyCopy = _a.withoutBodyCopy, componentClassNames = _a.componentClassNames, props = __rest(_a, ["className", "children", "options", "withoutBodyCopy", "componentClassNames"]);
    var markdownOptions = __assign({ 
        // Force all content to be wrapped in a "block" element.
        forceBlock: true, 
        // Force a wrapper even if it is only a single child.
        forceWrapper: true, overrides: {
            h1: {
                component: NvHeading,
                props: {
                    level: 1,
                },
            },
            h2: {
                component: NvHeading,
                props: {
                    level: 2,
                },
            },
            h3: {
                component: NvHeading,
                props: {
                    element: 'h3',
                    level: 3,
                },
            },
            h4: {
                component: NvHeading,
                props: {
                    element: 'h4',
                    level: 4,
                },
            },
            ol: {
                component: NvNumberedList,
            },
            table: {
                component: NvTableMarkdown,
                props: {
                    classNames: componentClassNames === null || componentClassNames === void 0 ? void 0 : componentClassNames.table,
                },
            },
            ul: {
                component: NvBulletedList,
            },
        }, 
        // Element that will wrap the content.
        wrapper: 'div' }, options);
    /**
     * Add rules to replace some pattern to a custom tag
     */
    var text = React.useMemo(function () { return [addSuperscript, addVimeoVideo].reduce(function (acc, rule) { return rule(acc); }, children); }, [children]);
    return (React.createElement(Markdown, __assign({}, props, { className: classNames(className, 'nv-markdown', { 'nv-body': !withoutBodyCopy }), options: markdownOptions }), text));
};

export { NvMarkdown as default };
//# sourceMappingURL=NvMarkdown.esm.js.map
